import ContactFormValidator from '../../validation/ContactFormValidator';
import { ValuationWidget } from '../../valuations/ValuationWidget';
require('../../modernizr/svg-animations.exec.js');

/**
 * Create a valuation widget on the target form, using the regNo and mileage elements as the inputs
 *
 * @param {HTMLElement} form
 * @param {HTMLElement} regNo
 * @param {HTMLElement} mileage
 * @param {boolean } disableLoading
 */
export default function(form, regNo, mileage, disableLoading = false) {
    if (!form || !regNo || !mileage) {
        return;
    }
    let loadingHtml = '<div class="loading solid-bg"><div class="center"><img class="valuation-widget__loading-img" src="/images/valuations/valuing.svg" alt="Loading" /><div class="loader-duration text-center"><p class="animated bounceIn">Please wait while we process your vehicle details request...</p></div></div></div>';
    let valuationWidget;
    if (!Modernizr.smil) {
        loadingHtml = '<div class="loading solid-bg"><div class="center"><img class="valuation-widget__loading-img" src="/images/valuations/valuing.gif" alt="Loading" /><div class="loader-duration text-center"><p class="animated bounceIn">Please wait while we process your vehicle details request...</p></div></div></div>';
        valuationWidget = new ValuationWidget({
            loadingImage: '<img class="valuation-widget__loading-img" src="/images/valuations/valuing.gif" alt="Loading" />',
        });
    }
    else {
        valuationWidget = new ValuationWidget();
    }

    if(disableLoading) {
        loadingHtml = '';
    }

    const valuationValidation = new ContactFormValidator({
        element: form,
        addClientId: false,
        loadingHtml: loadingHtml,
        loadingIntervalCallback: function (duration) {
            if (duration <= 5) {
                return true;
            }
            const durationContainer = form.querySelector('.loader-duration');
            if (!durationContainer) {
                return true;
            }
            // If we've been waiting between 5 and 10 seconds, add a p tag once
            if (duration > 5 && duration < 10) {
                const durationElement = durationContainer.querySelector('.duration-10');
                if (!durationElement) {
                    const paragraphElement = document.createElement('p');
                    paragraphElement.classList.add('valuation-widget__duration');
                    paragraphElement.classList.add('duration-10');
                    paragraphElement.classList.add('animated');
                    paragraphElement.classList.add('bounceIn');
                    paragraphElement.innerText = "Apologies for the delay...";
                    durationContainer.appendChild(paragraphElement);
                }
                return true;
            }

            const durationElement = durationContainer.querySelector('.duration-11');
            if (!durationElement) {
                const paragraphElement = document.createElement('p');
                paragraphElement.classList.add('valuation-widget__duration');
                paragraphElement.classList.add('duration-11');
                paragraphElement.classList.add('animated');
                paragraphElement.classList.add('bounceIn');
                paragraphElement.innerText = "We'll have your vehicle details very soon!";
                durationContainer.appendChild(paragraphElement);
                return true;
            }

            return true;
        }
    });

    form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (!valuationValidation.isValid()) {
            return;
        }
        valuationValidation.preventInput();
        // Pass the vehicle data to the widget class
        valuationWidget.setRegistration(regNo.value);
        valuationWidget.setMileage(mileage.value);

        // Call the API to get the vehicle data, and use the callbacks to render any UI changes
        valuationWidget.getVehicleInformation(function (success) {
            valuationValidation.successResponse();
        }, function (errors) {
            console.error(errors);
            valuationValidation.errorResponse(errors);
        });
    });

    return valuationWidget;
}


// WEBPACK FOOTER //
// ./resources/assets/js/valuations/modules/first-step-form-submit.js